var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 57,
    viewBox: "0 0 61 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_817_2542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.3824C0 6.74859 2.9544 3.79419 6.58821 3.79419H46.1174C49.7513 3.79419 52.7057 6.74859 52.7057 10.3824V43.3234C52.7057 46.9572 49.7513 49.9116 46.1174 49.9116H6.58821C2.9544 49.9116 0 46.9572 0 43.3234V10.3824Z",
    fill: "url(#paint0_linear_817_2542)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_817_2542)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.52,
    y: 20.2649,
    width: 44.4704,
    height: 31.294,
    fill: "url(#paint1_linear_817_2542)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.52,
    y: 10.3826,
    width: 16.4705,
    height: 16.4705,
    fill: "url(#paint2_linear_817_2542)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.22583 13.6768C8.22583 10.043 11.1802 7.08862 14.814 7.08862H54.3433C57.9771 7.08862 60.9315 10.043 60.9315 13.6768V46.6179C60.9315 50.2517 57.9771 53.2061 54.3433 53.2061H14.814C11.1802 53.2061 8.22583 50.2517 8.22583 46.6179V13.6768ZM41.558 24.64C41.0948 23.9606 40.333 23.5591 39.5198 23.5591C38.7066 23.5591 37.9345 23.9606 37.4816 24.64L28.5257 37.7753L25.7978 34.3679C25.3243 33.7812 24.614 33.4415 23.8728 33.4415C23.1316 33.4415 22.4111 33.7812 21.9478 34.3679L15.3596 42.6032C14.7626 43.3444 14.6493 44.3635 15.0611 45.2179C15.4729 46.0723 16.3376 46.6179 17.2846 46.6179H51.8727C52.7889 46.6179 53.633 46.1135 54.055 45.3002C54.4771 44.487 54.4256 43.5091 53.9109 42.7576L41.558 24.64ZM19.7552 23.5591C21.0657 23.5591 22.3225 23.0386 23.2491 22.1119C24.1758 21.1853 24.6963 19.9285 24.6963 18.618C24.6963 17.3075 24.1758 16.0507 23.2491 15.1241C22.3225 14.1974 21.0657 13.6768 19.7552 13.6768C18.4447 13.6768 17.1879 14.1974 16.2613 15.1241C15.3346 16.0507 14.814 17.3075 14.814 18.618C14.814 19.9285 15.3346 21.1853 16.2613 22.1119C17.1879 23.0386 18.4447 23.5591 19.7552 23.5591Z",
    fill: "url(#paint3_linear_817_2542)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_817_2542",
    x1: 0.823526,
    y1: 7.08829,
    x2: 59.2939,
    y2: 50.7352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6BCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7AEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_817_2542",
    x1: 25.52,
    y1: 29.3237,
    x2: 52.6963,
    y2: 49.0883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBCBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_817_2542",
    x1: 16.4612,
    y1: 15.3237,
    x2: 23.8729,
    y2: 21.9119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBCBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_817_2542",
    x1: 9.87288,
    y1: 10.3827,
    x2: 58.4609,
    y2: 51.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B794F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#805AD5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_817_2542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.7057,
    height: 52.7057,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_817_2542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.7057,
    height: 52.7057,
    fill: "white",
    transform: "translate(8.22583 3.79443)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/UploadImage.d70b3b6e2c58b0b30de3d335ec38f958.svg";
export { ForwardRef as ReactComponent };